import React from 'react'
import { observer } from 'mobx-react-lite'
import { EmptyState, Typography } from 'shared/ui'
import knowledgeBasePreviewImg from 'shared/assets/images/knowledgeBase/knowledge_base_preview.png'
import { LINK_KNOWLEDGE_BASE_HELP_GUIDE } from 'shared/constants/links'
import { getCDNAssetURL } from 'shared/lib'
import { KnowledgeBaseActions } from 'pages/settings/pages/knowledgeBase/pages/knowledgeBaseView/ui/KnowledgeBaseActions/KnowledgeBaseActions'
import { KnowledgeBaseUrlAlert } from 'pages/settings/pages/knowledgeBase/pages/knowledgeBaseView/ui/KnowledgeBaseNotifications/KnowledgeBaseUrlAlert'
import styles from './styles.module.scss'

export const KnowledgeBaseEmpty = observer(() => {
  return (
    <EmptyState
      title={
        <>
          <KnowledgeBaseUrlAlert margin='12px 0 20px 0' />
          <span className={styles.title}>
            <a
              href={LINK_KNOWLEDGE_BASE_HELP_GUIDE}
              target='_blank'
              rel='noreferrer'
              className={styles.previewImageContainer}
            >
              <img alt='Knowledge base preview' src={getCDNAssetURL(knowledgeBasePreviewImg)} />
            </a>
            <Typography variant={'heading-lg'} ariaLabel={'KnowledgeBaseTitle'}>
              Feed Your AI the Right Info
            </Typography>
          </span>
        </>
      }
      text='Upload content to your AI Knowledge Base so your AI agents can respond with the right answers — fast'
      actions={<KnowledgeBaseActions />}
      typographyProps={{
        variant: 'body-lg-regular',
        ariaLabel: 'KnowledgeBaseText',
        className: styles.subTitleText,
      }}
      boxProps={{
        gap: '20px',
        width: 'unset',
        height: '100%',
      }}
      noIcon
    />
  )
})
